"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trengoModal = exports.contactModal = void 0;
require("../scss/main.scss");
var Accordion_1 = __importDefault(require("./components/Accordion"));
var Slider_1 = __importStar(require("./components/Slider"));
var StickyHeader_1 = __importDefault(require("./components/StickyHeader"));
var Navigation_1 = __importDefault(require("./components/navigation/Navigation"));
var SliderArrowPosition_1 = __importDefault(require("./components/SliderArrowPosition"));
var Panorama_1 = __importDefault(require("./components/Panorama"));
var QuickMessage_1 = __importDefault(require("./components/QuickMessage"));
var Flatpickr_1 = __importDefault(require("./components/Flatpickr"));
var StickyButtons_1 = __importDefault(require("./components/StickyButtons"));
var TrengoModal_1 = __importDefault(require("./components/TrengoModal"));
var Modal_1 = __importDefault(require("./components/Modal"));
document.addEventListener('DOMContentLoaded', function () {
    new Accordion_1.default();
    new Slider_1.default();
    new Slider_1.SplideSliderTeaserboxes();
    new StickyHeader_1.default();
    new Navigation_1.default();
    new SliderArrowPosition_1.default();
    new Panorama_1.default();
    new QuickMessage_1.default();
    new Flatpickr_1.default();
    new StickyButtons_1.default();
    exports.contactModal = new Modal_1.default('contact');
    exports.trengoModal = new TrengoModal_1.default();
});
